import Vue from 'vue'
import VueMeta from 'vue-meta'
import './global_extensions'
import './assets/tailwind.css'
import router from './router'

Vue.use(VueMeta)

Vue.config.productionTip = false

do ->
  { dims } = new Vue data: -> dims: { width: 0, height: 0 }
  Vue.prototype.$dimensions = dims

  resized = ->
    dims.width = document.documentElement.clientWidth
    dims.height = document.documentElement.clientHeight

  window.addEventListener 'resize', resized
  resized()

new Vue({ router }).$mount('#app')
